import { Box, Modal } from "@mui/material";
import { ContainerActions, ContainerModalStyled } from "./confirm-modal.styled";
import { NormalText } from "../styles";
import { Button } from "../button/button";

export const ConfirmModal = ({
  children,
  isOpen,
  title,
  handleClose,
  onConfirm,
  onCancel,
  // El envio de una transferencia tarda ~14 s. Sin esto el boton Confirmar
  // queda clickeable todo ese tiempo, no pasa nada visible, y el usuario vuelve
  // a apretar: se emite la transferencia DOS VECES. Paso en produccion el
  // 2026-08-19 con dinero real (2 x 0.1 USDT y 4 transacciones de gas).
  isLoading = false,
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={isLoading ? undefined : handleClose}
      dismiss={{ enabled: false }}
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(220, 215, 215, 0.25)",
        },
      }}
    >
      <ContainerModalStyled>
        {title && (
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            borderBottom={"1px solid #cbcbcb"}
            padding={"0 24px 24px 24px"}
            marginBottom={"24px"}
          >
            <NormalText size={18} isBold color="#0F110C">
              {title?.toUpperCase()}
            </NormalText>
            <Button
              onClick={handleClose}
              startIcon={"X"}
              type={"regular"}
              iconSize={18}
            />
          </Box>
        )}
        <Box width={"100%"} padding={"0 24px 24px 24px"}>
          {children}
        </Box>
        <ContainerActions>
          {onCancel && (
            <Button
              label={"Cancelar"}
              onClick={onCancel}
              type={"regular"}
              isDisabled={isLoading}
            />
          )}
          {onConfirm && (
            <Button
              label={"Confirmar"}
              onClick={onConfirm}
              type={"contained"}
              isLoading={isLoading}
            />
          )}
        </ContainerActions>
      </ContainerModalStyled>
    </Modal>
  );
};
